"use strict";
exports.__esModule = true;
exports.ShopifyOrderBuilder = exports.ShopifyOrderLineItemBuilder = exports.ShopifyOrderLineItem = exports.ShopifyOrderFulfillmentStatus = void 0;
var core_common_domain_1 = require("@jewelutions/core-common-domain");
var core_designer_domain_1 = require("@jewelutions/core-designer-domain");
var ShopifyOrderFulfillmentStatus;
(function (ShopifyOrderFulfillmentStatus) {
    ShopifyOrderFulfillmentStatus["FULFILLED"] = "FULFILLED";
    ShopifyOrderFulfillmentStatus["UNFULFILLED"] = "UNFULFILLED";
})(ShopifyOrderFulfillmentStatus = exports.ShopifyOrderFulfillmentStatus || (exports.ShopifyOrderFulfillmentStatus = {}));
var ShopifyOrderLineItem = /** @class */ (function () {
    function ShopifyOrderLineItem() {
    }
    ShopifyOrderLineItem.retrieveItemCustomisation = function (lineItem) {
        var customAttribute = lineItem.customAttributes.find(function (ca) { return ca.key === core_designer_domain_1.WebshopOrder.orderLineCustomAttributes.designSessionState; });
        if (!customAttribute)
            return undefined;
        return core_designer_domain_1.WebshopOrder.decodeItemCustomisation(customAttribute.value);
    };
    ShopifyOrderLineItem.containsItemCustomisation = function (lineItem) {
        return ShopifyOrderLineItem.retrieveItemCustomisation(lineItem) !== undefined;
    };
    return ShopifyOrderLineItem;
}());
exports.ShopifyOrderLineItem = ShopifyOrderLineItem;
var ShopifyOrderLineItemBuilder = /** @class */ (function () {
    function ShopifyOrderLineItemBuilder(item) {
        this.item = item;
    }
    ShopifyOrderLineItemBuilder.initialise = function (shopifyLineItemId, quantity, shopifyProductId, shopifyProductVariantId) {
        return new ShopifyOrderLineItemBuilder({
            id: shopifyLineItemId,
            quantity: quantity,
            shopifyProductId: shopifyProductId,
            shopifyProductVariantId: shopifyProductVariantId,
            customAttributes: []
        });
    };
    ShopifyOrderLineItemBuilder.prototype.setItemCustomisation = function (itemCustomisation) {
        return this.addCustomAttribute(core_designer_domain_1.WebshopOrder.orderLineCustomAttributes.designSessionState, core_designer_domain_1.WebshopOrder.encodeItemCustomisation(itemCustomisation));
    };
    ShopifyOrderLineItemBuilder.prototype.addCustomAttribute = function (key, value) {
        this.guardValidCustomAttributeValidKeys(key);
        if (this.existsCustomAttribute(key))
            throw new core_common_domain_1.Exception(key + " is already set in the custom shopify order line item. Cannot add a duplicate. Aborting.");
        this.item.customAttributes.push({ key: key, value: value });
        return this;
    };
    ShopifyOrderLineItemBuilder.prototype.existsCustomAttribute = function (key) {
        this.guardValidCustomAttributeValidKeys(key);
        return this.item.customAttributes.find(function (ca) { return ca.key === key; }) !== undefined;
    };
    ShopifyOrderLineItemBuilder.prototype.deleteCustomAttributeIfPresent = function (key) {
        this.guardValidCustomAttributeValidKeys(key);
        this.item.customAttributes = this.item.customAttributes.filter(function (ca) { return ca.key !== key; });
        return this;
    };
    ShopifyOrderLineItemBuilder.prototype.guardValidCustomAttributeValidKeys = function (key) {
        if (key !== core_designer_domain_1.WebshopOrder.orderLineCustomAttributes.designSessionState)
            throw new core_common_domain_1.Exception(key + " is not a valid shopify order item custom attribute key");
    };
    ShopifyOrderLineItemBuilder.prototype.build = function () {
        return this.item;
    };
    return ShopifyOrderLineItemBuilder;
}());
exports.ShopifyOrderLineItemBuilder = ShopifyOrderLineItemBuilder;
var ShopifyOrderBuilder = /** @class */ (function () {
    function ShopifyOrderBuilder(shopifyOrder) {
        this.shopifyOrder = shopifyOrder;
    }
    ShopifyOrderBuilder.initiate = function (id, deliveryAddress, fullyPaid, createdAt, updatedAt) {
        return new ShopifyOrderBuilder({
            id: id,
            name: "Order " + id,
            deliveryAddress: deliveryAddress,
            createdAt: createdAt,
            updatedAt: updatedAt,
            fullyPaid: fullyPaid,
            displayFulfillmentStatus: ShopifyOrderFulfillmentStatus.UNFULFILLED,
            note: '',
            lineItems: [],
            customAttributes: []
        });
    };
    ShopifyOrderBuilder.prototype.getId = function () {
        return this.shopifyOrder.id;
    };
    ShopifyOrderBuilder.prototype.withId = function (id) {
        this.shopifyOrder.id = id;
        return this;
    };
    ShopifyOrderBuilder.prototype.withNote = function (note) {
        this.shopifyOrder.note = note;
        return this;
    };
    ShopifyOrderBuilder.prototype.withName = function (name) {
        this.shopifyOrder.name = name;
        return this;
    };
    ShopifyOrderBuilder.prototype.addOrderLineItem = function (lineItem) {
        this.shopifyOrder.lineItems.push(lineItem);
        return this;
    };
    ShopifyOrderBuilder.prototype.existsOrderLineItem = function (lineItemId) {
        return this.shopifyOrder.lineItems.find(function (lineItem) { return lineItem.id === lineItemId; }) !== undefined;
    };
    ShopifyOrderBuilder.prototype.deleteOrderLineItemIfPresent = function (lineItemId) {
        this.shopifyOrder.lineItems = this.shopifyOrder.lineItems.filter(function (lineItem) { return lineItem.id !== lineItemId; });
        return this;
    };
    ShopifyOrderBuilder.prototype.setFullyPaid = function (fullyPaid) {
        this.shopifyOrder.fullyPaid = fullyPaid;
        return this;
    };
    ShopifyOrderBuilder.prototype.setDisplayFulfillmentStatus = function (displayFulfillmentStatus) {
        this.shopifyOrder.displayFulfillmentStatus = displayFulfillmentStatus;
        return this;
    };
    ShopifyOrderBuilder.prototype.addCustomAttribute = function (key, value) {
        if (this.existsCustomAttribute(key))
            throw new core_common_domain_1.Exception(key + " is already set in the custom shopify order item. Cannot add a duplicate. Aborting.");
        this.shopifyOrder.customAttributes.push({ key: key, value: value });
        return this;
    };
    ShopifyOrderBuilder.prototype.existsCustomAttribute = function (key) {
        return this.shopifyOrder.customAttributes.find(function (ca) { return ca.key === key; }) !== undefined;
    };
    ShopifyOrderBuilder.prototype.deleteCustomAttributeIfPresent = function (key) {
        this.shopifyOrder.customAttributes = this.shopifyOrder.customAttributes.filter(function (ca) { return ca.key !== key; });
        return this;
    };
    ShopifyOrderBuilder.prototype.build = function () {
        return this.shopifyOrder;
    };
    return ShopifyOrderBuilder;
}());
exports.ShopifyOrderBuilder = ShopifyOrderBuilder;
